import mitt from 'mitt';
import { createApp } from 'vue'
import App from './App.vue'

let app = createApp(App);

 // Global internal $emitter to communicate between components.
app.config.globalProperties.$emitter = mitt();

app.mount('#app');
